import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "table table-striped" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  width: "10"
}, "#", -1)
const _hoisted_4 = {
  scope: "col",
  width: "400"
}
const _hoisted_5 = {
  scope: "col",
  width: "400"
}
const _hoisted_6 = {
  scope: "col",
  width: "100"
}
const _hoisted_7 = ["onUpdate:modelValue", "onChange"]
const _hoisted_8 = ["onUpdate:modelValue", "onChange"]
const _hoisted_9 = ["onClick"]

import { translation } from "../../../lang/Translation";
import { MessageDialog } from "../../../../framework/frontend/MessageDialog";
import { ClassRoomService } from "../../../biz/remote/ClassRoomService";
import { SessionUser } from "../../../utils/SessionUser";
import { ClassMembers } from "../../../../server/dto/generated/ClassMembers";

interface Prop {
  list: ClassMembers[];
  onAddUser: (member: ClassMembers) => void;
  onDeleteUser: (index: number) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberInvitationList',
  props: {
    list: { default: () => {
    return [];
  } },
    onAddUser: null,
    onDeleteUser: null
  },
  setup(__props: any) {

const prop = __props as { list: ClassMembers[], onAddUser: (member: ClassMembers) => void, onDeleteUser: (index: number) => void };

const t = translation;


const addNewMember = async () => {
  const biz = new ClassRoomService();
  const teacher_id = SessionUser.instance.userId;
  const response = await biz.addNewMember(teacher_id,"");
  prop.onAddUser(response.data);
  MessageDialog.info(t.to("メンバーを追加しました", "added_member"));
};

const save = async (member: ClassMembers) => {
  const biz = new ClassRoomService();
  await biz.updateMember(member);
  MessageDialog.info(
    t.to(`メンバーを更新しました`, "saved_class_member") + `[${member.member_id}]`
  );
};
const deleteMember = async (member: ClassMembers, index: number) => {
  const biz = new ClassRoomService();

  const deleteConfirmMessage = t.to(
    "を削除します。よろしいですか？",
    "confirm_delete_class_member"
  );
  const isOK = await MessageDialog.confirm(deleteConfirmMessage);
  if (isOK) {
    await biz.deleteMember(member);

    // 削除したことを上位コンポーネントに通知
    prop.onDeleteUser(index);

    MessageDialog.info(
      t.to(`メンバーを削除しました`, "deleted_class_member") + `[${member.member_id}]`
    );
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_unref(t).to("1. メンバーリストを作成", "member_list")), 1),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_3,
          _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(t).to("クラス名", "className")), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(t).to("名前", "name")), 1),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t).to("削除", "delete")), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (member, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, _toDisplayString(member.member_id), 1),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((member.className) = $event),
                class: "form-control w-100",
                onChange: ($event: any) => (save(member))
              }, null, 40, _hoisted_7), [
                [_vModelText, member.className]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((member.name) = $event),
                class: "form-control w-100",
                onChange: ($event: any) => (save(member))
              }, null, 40, _hoisted_8), [
                [_vModelText, member.name]
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: ($event: any) => (deleteMember(member, index))
              }, _toDisplayString(_unref(t).to("削除", "delete")), 9, _hoisted_9)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", { class: "d-flex w-100" }, [
      _createElementVNode("div", { class: "w-25" }, [
        _createElementVNode("button", {
          class: "btn rounded-circle btn-lg btn-danger",
          onClick: addNewMember
        }, " + ")
      ])
    ])
  ]))
}
}

})